import axios from "axios";
import { VUE_APP_ROOT_API } from "@/env";

export const Client = axios.create({
  baseURL: `${VUE_APP_ROOT_API}`,
  headers: { "Content-Type": "application/json" }
});

Client.interceptors.request.use((config) => {
  // Axios 1.x + instance-level Content-Type can break FormData uploads.
  // Let the browser set multipart boundaries automatically.
  if (config?.data instanceof FormData) {
    if (config.headers) {
      delete config.headers["Content-Type"];
      delete config.headers["content-type"];
    }
  }

  return config;
});
